@if (column$ | async; as col) {
  <span class="layout-row place-end-center gap-xs">
    <div>{{ col?.name | translate }}</div>
  </span>
}
